import { z } from 'zod/v3';
import {
  transformNullish,
  transformToValidPeriod,
  zIsoDate,
} from '../../../common/utils';
import { zAlgorithmType } from './zAlgorithmType';

export const AlgorithmBasicBaseSchema = z.object({
  id: transformNullish(z.number().readonly(), -1),
  typeCode: zAlgorithmType.nullable(),
  code: transformNullish(z.string(), ''),
  groupCode: transformNullish(z.string(), ''),
  sequenceNumber: z.number(),
  validFrom: zIsoDate().nullable(),
  validTo: zIsoDate().nullable(),
  statusId: transformNullish(z.number(), -1),
  statusName: transformNullish(z.string(), ''),
  description: transformNullish(z.string(), ''),
  execAfterAggregation: z.boolean().nullable(),
  filterClause: transformNullish(z.string(), ''),
  aggregatePeriods: z.boolean().nullish(),
  expression: transformNullish<string>(z.string(), ''),
});

const transform = <T extends typeof AlgorithmBasicBaseSchema.shape>(
  schemaVariant: z.ZodObject<T>,
) =>
  transformToValidPeriod(schemaVariant) // Workaround for known issue: https://github.com/colinhacks/zod/issues/2732
    .transform(
      (data) => data as Omit<typeof data, 'id'> & { readonly id: number },
    );

export const AlgorithmBasicSchema = transform(AlgorithmBasicBaseSchema);
